import { connect } from 'react-redux';
import { createToolbarEvent } from '../../analytics/AnalyticsEvents';
import { sendAnalytics } from '../../analytics/functions';
import { translate } from '../../base/i18n/functions';
import { IconSIPConnect } from '../../base/icons/svg';
import AbstractButton from '../../base/toolbox/components/AbstractButton';
/**
 * React {@code Component} responsible for displaying a button in the overflow
 * menu of the toolbar, including an icon showing the currently selected
 * max receive quality.
 *
 * @augments Component
 */
class CallSipButton extends AbstractButton {
    constructor() {
        // accessibilityLabel = 'toolbar.accessibilityLabel.callQuality';
        // label = 'videoStatus.performanceSettings';
        // tooltip = 'videoStatus.performanceSettings';
        // icon = IconPerformance;
        super(...arguments);
        this.accessibilityLabel = 'videoSIPGW.SIP';
        this.label = 'videoSIPGW.SIP';
        this.tooltip = 'videoSIPGW.SIP';
        this.icon = IconSIPConnect;
    }
    /**
    * Handles clicking the button, and opens the video quality dialog.
    *
    * @private
    * @returns {void}
    */
    _handleClick() {
        const { dispatch, handleClick } = this.props;
        sendAnalytics(createToolbarEvent('sip'));
        handleClick();
        // dispatch(openDialog(CallSIPDialog));
        // dispatch(openDialog(ListenSIPDialog));
    }
}
export default connect()(translate(CallSipButton));
